import { useMutation, useQueryClient } from '@tanstack/react-query';
import { systemSettingApi } from '../api/systemSetting.api';
import { systemSettingKeys } from '../api/systemSetting.keys';
import toast from 'react-hot-toast';

export function useCreateSystemSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => systemSettingApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: systemSettingKeys.all });
      toast.success('System setting created');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to create setting');
    },
  });
}

export function useUpdateSystemSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => systemSettingApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: systemSettingKeys.all });
      toast.success('System setting updated');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to update setting');
    },
  });
}

export function useDeleteSystemSetting() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => systemSettingApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: systemSettingKeys.all });
      toast.success('System setting deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete setting');
    },
  });
}
